<!-- 
Levy collections listing page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Levy collections"
      user-guide-topic="listing-levy-collections"
    />
    <our-actions-bar 
      :actions="actions" 
      xs-breakpoint
      @create="showCreateDialog = true" 
      @sandbox="showSandboxesDialog = true"
    />
    <levy-collection-listing @click="open"/>
    <create-levy-collection-dialog v-model="showCreateDialog"/>
    <sandboxes-dialog v-model="showSandboxesDialog"/>
  </div>
</template>

<script>
import * as claim from "@/store/claim-types";
import lookupMixins from "@/mixins/lookup.mixins";
import LevyCollectionListing from "@/components/levy-collections/LevyCollectionListing.vue";
import CreateLevyCollectionDialog from "@/components/levy-collections/CreateLevyCollectionDialog.vue";
import SandboxesDialog from "@/components/sandboxes/SandboxesDialog.vue";

export default {
  name: "LevyCollections",
  components: {
    LevyCollectionListing,
    CreateLevyCollectionDialog,
    SandboxesDialog
  },
  mixins: [lookupMixins],
  data() {
    return {
      showAll: false,
      showCreateDialog: false,
      showSandboxesDialog: false
    };
  },
  computed: {
    actions() {
      const actions = [];
      if (this.canCreate) {
        actions.push({ text: "Start a new levy collection", emit: "create", icon: "add_circle_outline" });
      }
      if (this.canEditSandboxes) {
        actions.push({ text: "Levy collection sandboxes", emit: "sandbox", icon: "move_to_inbox" });
      }
      return actions;
    },
    canEditSandboxes() {
      return this.$store.getters.claims.includes(claim.LEVY_COLLECTION_SANDBOXES);
    },
    canCreate() {
      return this.$store.getters.claims.includes(claim.LEVY_COLLECTION_CREATE);
    },
    breadcrumbs() {
      return [{ text: "Levy collections" }];
    }
  },
  methods: {
    open(id, levyCollection) {
      if (this.doesLookupHaveAttribute(levyCollection.type, "IsSandbox", this.lookups.levyCollectionTypes)) {
        this.$router.push(`/levy-collections/${id}/sandbox`);
      } else {
        this.$router.push(`/levy-collections/${id}`);
      }
    }
  }
};
</script>
